import { path } from 'ramda';
import { combineReducers } from 'redux';

import { FETCH_LAST_PAYOUT, FETCH_PAYOUTS_REPORT, FETCH_DAILY_PAYROLL_REPORT } from '../../main/reports/constants';

const hasShop = path(['payload', 'shop']);

const endOfPayoutById = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PAYOUTS_REPORT: {
      const { shopId } = action;

      return {
        ...state,
        [shopId]: action.payload.toDate,
      };
    }
    default:
      return state;
  }
};

const totalForPayout = shop => (
  shop.totalServicesPosRevenue + shop.totalServicesStripeRevenue + shop.totalProductsPosRevenue + shop.giftCardForCommission
);

const totalById = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PAYOUTS_REPORT: {
      if (!hasShop(action)) {
        return state;
      }
      const { shopId } = action;

      return {
        ...state,
        [shopId]: totalForPayout(action.payload.shop),
      };
    }
    default:
      return state;
  }
};

const dailyPayrollById = (state = {}, action) => {
  switch (action.type) {
    case FETCH_DAILY_PAYROLL_REPORT: {
      const { shopId } = action;

      return {
        ...state,
        [shopId]: action.payload,
      };
    }
    default:
      return state;
  }
};

const lastPayoutDateId = (state = {}, action) => {
  switch (action.type) {
    case FETCH_LAST_PAYOUT: {
      const { shopId } = action;
      return {
        ...state,
        [shopId]: action.payload,
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  endOfPayoutById,
  totalById,
  lastPayoutDateId,
  dailyPayrollById,
});
